export default __webpack_public_path__ + "media/images/fonts/Flaticon-a01386d2c7976b986932d447dc1b1e20.eot";